export enum DocType {
    Datasheet,
    Drawing
}
